import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import withRouter from "../../components/Common/withRouter";
import { useNavigate } from "react-router-dom";
import { setLogout } from "../../store/slices/authSlice";
import { toast, Bounce } from "react-toastify";
import { get } from "../../api/axios";
import endpoints from "../../api/endpoints";

const Logout = () => {
  document.title = " Logout | Dock Tok - Admin Dashboard";
  const { currentUser } = useSelector((state) => state.auth);
  const history = useNavigate();
  const dispatch = useDispatch();
  const logoutApi = async () => {
    const resp = await get(`${endpoints.logout}/${currentUser.id}`);
    dispatch(setLogout());
    toast.success("Logout Successfully", {
      position: "bottom-center",
      theme: "colored",
      transition: Bounce,
    });
  };

  useEffect(() => {
    logoutApi();
    localStorage.removeItem("accessToken");

    history("/login");
  }, [dispatch, history]);

  return <></>;
};

Logout.propTypes = {
  history: PropTypes.object,
  logoutUser: PropTypes.func,
};

// export default withRouter(connect(null, { logoutUser })(Logout))
export default withRouter(Logout);
